import type { Variant } from '../types.ts';

export const STANDARD_FEN = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

/** Day 0: plain chess. Available, never promoted. */
export const classic: Variant = {
  id: 'classic',
  info: {
    name: 'Classic Chess',
    but: "it's just chess",
    tagline: 'The original. No twist, no excuses.',
    summary: 'Regular chess. **No twist at all.** Here for warm-ups, purists, and anyone who misses normal.',
    rules: [
      'Standard chess rules: checkmate wins.',
      'Castling, en passant and promotion as usual.',
      'Stalemate, threefold repetition, the 50-move rule and insufficient material are draws.',
    ],
    accent: '#c9c4d6',
    emoji: '♟️',
  },
  startFen: STANDARD_FEN,
  insufficientMaterial: true,
};
